export function isProduction(): boolean {
  return process.env.NEXT_PUBLIC_DEPLOY_ENV === 'production';
}
